const { transferQuantity } = require('./transferQuantity');
const { getDestinationItem } = require('./getDestinationItem');
const zipFold = require('../utils/zipFold')

const baseKeys = ['producerproduct_id','consumer_price','quantity','percentage','reason','tva'];

const MODULE = {};

const reducePct = (value, pct) => {
  return Math.ceil(value * ((100 - pct) / 100));
}

// base methods

MODULE.getUnitPrice = function(item){
  return item.consumer_price
}

MODULE.getUnitPriceHT = function(item){

  const unitPrice = MODULE.getUnitPrice(item);
  return Math.ceil(( unitPrice * 100) / (100 + item.tva))
}

MODULE.getUnitPriceTVA = function(item){

  const unitPrice = MODULE.getUnitPrice(item);
  const unitPriceHT = MODULE.getUnitPriceHT(item);
  return unitPrice - unitPriceHT;
}

MODULE.getFullValue = function(item){
  return MODULE.getUnitPrice(item) * item.quantity;
}

MODULE.getFullValueHT = function(item){
  return MODULE.getUnitPriceHT(item) * item.quantity;
}

MODULE.getFullValueTVA = function(item){
  return MODULE.getUnitPriceTVA(item) * item.quantity;
}

MODULE.getReducedUnitPrice = function(item){
  
  const value = MODULE.getUnitPrice(item)
  return reducePct(value, item.percentage ? item.percentage : 0);
}

MODULE.getReducedUnitPriceHT = function(item){
  
  const value = MODULE.getUnitPriceHT(item);
  return reducePct(value, item.percentage ? item.percentage : 0);
}

MODULE.getReducedUnitPriceTVA = function(item){
  
  const value = MODULE.getUnitPriceTVA(item);
  return reducePct(value, item.percentage ? item.percentage : 0);
}

MODULE.getReducedValue = function(item){

  const value = MODULE.getFullValue(item);
  return reducePct(value, item.percentage ? item.percentage : 0);
}

MODULE.getReducedValueHT = function(item){
  
  const value = MODULE.getFullValueHT(item)
  return reducePct(value, item.percentage ? item.percentage : 0);
}

MODULE.getReducedValueTVA = function(item){

  const value = MODULE.getFullValueTVA(item);
  return reducePct(value, item.percentage ? item.percentage : 0);
}


class OrderItem {

  constructor(data, keysToCopy){
    const keys = Array.from(new Set([
      ...keysToCopy,
      ...baseKeys
    ]));
   
    for(let key of keys){
      if(typeof data[key] !== 'undefined'){
        this[key] = data[key]
      }
    }
  }

  getUnitPrice(){
    return MODULE.getUnitPrice(this)
  }

  getUnitPriceHT(){
    return MODULE.getUnitPriceHT(this)
  }

  getFullValue(){
    return MODULE.getFullValue(this)
  }

  getFullValueTVA(){
    return MODULE.getFullValueTVA(this)
  }

  getFullValueHT(){
    return MODULE.getFullValueHT(this)
  }

  getReducedValue(){
    return MODULE.getReducedValue(this)
  }

  getReducedValueTVA(){
    return MODULE.getReducedValueTVA(this)
  }

  getReducedUnitPrice(){
    return MODULE.getReducedUnitPrice(this)
  }

  getReducedUnitPriceHT(){
    return MODULE.getReducedUnitPriceHT(this)
  }

  getReducedValueHT(){
    return MODULE.getReducedValueHT(this)
  }
}

MODULE.createOrderItem = (item, keysToCopy = []) => {
  return new OrderItem(item, keysToCopy);
}

MODULE.formatOrderItem = (item, keysToCopy = []) => {
  const orderItem = MODULE.createOrderItem(item, keysToCopy);
  const base = {};
  for(let key of keysToCopy){
    if(typeof item[key] !== 'undefined'){
      base[key] = item[key]
    }
  }
  return {
    ...base,
    unit_price: orderItem.getUnitPrice(),
    full_value: orderItem.getFullValue(),
    unit_price_ht: orderItem.getUnitPriceHT(),
    full_value_ht: orderItem.getFullValueHT(),
    full_value_tva: orderItem.getFullValueTVA(),
    reduced_value: orderItem.getReducedValue(),
    reduced_value_ht: orderItem.getReducedValueHT(),
    reduced_unit_price: orderItem.getReducedUnitPrice(),
    reduced_unit_price_ht: orderItem.getReducedUnitPriceHT(),
    reduced_value_tva: orderItem.getReducedValueTVA(),
  }
}

MODULE.wrapItems = (items, keysToCopy = []) => {
  return items.map(item => MODULE.createOrderItem(item, keysToCopy))
}

MODULE.calculateAmountTotalFromItems = function({ 
  items = [], 
  reduced = [], 
  added = [], 
  added_reduced = [],
  added_charges = [],
  references,
  strictEqual = false,
  refMatchKey = 'producerproduct_id'
}, { getHT = false, tva, getTVA = false } = {}){

  const keysToCopy = [...baseKeys, 'kelbongoo_price'];

  const getTotal = ({ array, references, isReduced = false }) => {

    if(
      references && references.length > 0
    ){
      let isMatch = (f,i) => strictEqual
        ? f[refMatchKey] === i.producerproduct_id
        : f[refMatchKey].equals(i.producerproduct_id);

      array = zipFold.run(array, references, isMatch, keysToCopy);
    }

    return MODULE.wrapItems(array, keysToCopy)
      .filter(item => {
        if(!tva) return true;
        return item.tva === tva;
      })
      .reduce(
        (acc, item) => {
          let value;

          if(getHT){
            value = isReduced ? item.getReducedValueHT() : item.getFullValueHT();
          }
          else if(getTVA){
            value = isReduced ? item.getReducedValueTVA() : item.getFullValueTVA();
          }
          else {
            value = isReduced ? item.getReducedValue() : item.getFullValue();
          }
          return acc += value;
        },
        0
      );
  }

  const itemsTotal = getTotal({ array: items, references })

  const reducedTotal = getTotal({ array: reduced, references, isReduced: true });
  const addedTotal = getTotal({ array: added, references })
  const addedReducedTotal = getTotal({ array: added_reduced, references, isReduced: true })
  const addedChargesTotal = added_charges.reduce((acc, c) => {
    let amount = getHT
      ? c.amount_ht
      : getTVA
        ? (c.amount - c.amount_ht)
        : c.amount;
    acc += amount;
    return acc;
  }, 0);

  return itemsTotal + reducedTotal + addedTotal + addedReducedTotal + addedChargesTotal;
}

MODULE.calculateUnitsTotalFromItems = function({ 
  items = [], 
  reduced = [], 
  added = [], 
  added_reduced = []
}){

  return items.concat(reduced, added, added_reduced)
    .reduce(
      (acc, item) => acc += item.quantity,
      0
    );
}

MODULE.calculateTVARateFromItems = function({ items = [], reduced = [] }){

  const amountTotalHT = MODULE.calculateAmountTotalFromItems({
    items,
    reduced
  }, { getHT: true })

  const amountTotalTTC = MODULE.calculateAmountTotalFromItems({ 
    items, 
    reduced
  });

  return Math.round(((amountTotalTTC / amountTotalHT) - 1) * 10000) / 100;
}

MODULE.getProducerProductIds = function({ 
  items = [], 
  reduced = [], 
  removed = [], 
  added = [], 
  added_reduced = [] 
}, useObjectIds = false){

  const source = items.concat(reduced, removed, added, added_reduced);

  if(useObjectIds){
    const tmp = [
      ...new Set(source.map(item => item.producerproduct_id.toString()))
    ];
    return tmp.map(i => mongoose.Types.ObjectId(i))
  }

  return [
    ...new Set(source.map(item => item.producerproduct_id))
  ];
}

MODULE.calculateAmountTotal = function({ order, getHT = false, tva, getTVA = false }){

  return MODULE.calculateAmountTotalFromItems({ 
    items: order.items, 
    reduced: order.reduced,
    added: order.added || [],
    added_reduced: order.added_reduced || [],
    added_charges: order.added_charges || []
  }, { getHT, tva, getTVA });
}

MODULE.calculateUnitsTotal = function({ order }){

  return MODULE.calculateUnitsTotalFromItems({ 
    items: order.items, 
    reduced: order.reduced,
    added: order.added || [],
    added_reduced: order.added_reduced || []
  });
}

MODULE.calculateTVARate = function({ order }){

  return MODULE.calculateTVARateFromItems({
    items: order.items,
    reduced: order.reduced
  })
}



module.exports = Object.assign(MODULE, {
  transferQuantity,
  getDestinationItem
});
